<script>
  import TopAppBar, {Row, Section, Title} from '@smui/top-app-bar';
  import IconButton from '@smui/icon-button';
  export let title;
  export let back = false;
  let prominent = false;
  let dense = false;
  let secondaryColor = false;
</script>

<style>
</style>

<TopAppBar variant="static" {prominent} {dense} color={secondaryColor ? 'secondary' : 'primary'}>
<Row>
    <Section>
    {#if back}
    <IconButton class="material-icons" on:click={() => window.history.go(-1)}>arrow_back</IconButton>
    {/if}
    <Title>{title}</Title>
    </Section>
</Row>
</TopAppBar>